export default function (props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="1em" height="1em" viewBox="0 0 23 24" version="1.1">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(-25.000000, -921.000000)">
                    <g transform="translate(0.000000, 114.000000)">
                        <g transform="translate(0.000000, 32.214047)">
                            <g id="people_icon" transform="translate(25.000000, 775.150502)">
                                <rect id="矩形" x="0" y="0" width="23" height="23.1538462" />
                                <g id="编组-5" transform="translate(3.541769, 1.929487)" stroke="#03060B" strokeWidth="1.79564">
                                    <ellipse id="椭圆形" cx="7.81498016" cy="5.87867889" rx="4.86358873" ry="4.98085889" />
                                    <path d="M15.9722222,19.2948718 C15.9722222,14.794489 12.3967185,11.146208 7.98611111,11.146208 C3.57550373,11.146208 0,14.794489 0,19.2948718" />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
